import { loading as loadingModule } from '../loading'

import { Actions, Module } from 'vuex-smart-module'

import { Header } from '@/models/tables'

import { TableLoadingGetters, TableMutations, TableState } from '@/store/mixins/table'
import { PointsService, TransactionsHistory } from '@/api'

export type HistoryPointsTableItem = TransactionsHistory

const loading = loadingModule.clone()

export class HistoryPointsState extends TableState<HistoryPointsTableItem> {
  itemsPerPageOptions = [5, 10, 15] as const
  tableHeaders: Array<Header> = [
    new Header('Тип операции', 'isAccrual', false, 'start'),
    new Header('Дата и время', 'date', false, 'center'),
    new Header('Количество баллов', 'numberOfPoints', false, 'end'),
  ]
}

export class HistoryPointsGetters extends TableLoadingGetters<HistoryPointsActions, HistoryPointsState> {
  get isTableItemsGet() {
    return this.state.loading.loaders.getTableItems
  }
}

export class HistoryPointsMutations extends TableMutations<HistoryPointsState> {}

export class HistoryPointsActions extends Actions<
  HistoryPointsState,
  HistoryPointsGetters,
  HistoryPointsMutations,
  HistoryPointsActions
> {
  async getTableItems() {
    const { limit, offset } = this.getters.tableParams
    const { history, count } = await PointsService.getPointsTransactionList({
      limit,
      offset,
    })
    this.mutations.setTableCount(count)
    this.mutations.setTableItems(history)
  }
}

export const historyPoints = new Module({
  state: HistoryPointsState,
  getters: HistoryPointsGetters,
  mutations: HistoryPointsMutations,
  actions: HistoryPointsActions,
  modules: {
    loading,
  },
})
